import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpRequest
} from '@angular/common/http';
import { environment } from "../../../environments/environment";

@Injectable()
export class JsonInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // Adding headers for Sphinnx to Sphinnx communication only
        if (req.url.toLowerCase().includes(environment.apiEndpoint)) {
            const authReq = req.clone({
                headers: req.headers.set('Content-Type', 'application/json; charset=utf-8')
                                    .append('Cache-Control', 'no-cache') // HTTP 1.1
                                    .append('Pragma', 'no-cache') // HTTP 1.0 (IE11)
                                    .append('Expires', '0')
            });
            return next.handle(authReq);
        }

        return next.handle(req);
    }
}
